import { GetURLParams } from '@buyhatke/custom-lib-js';

import { checkDocument, Harpic } from '@utils/customLib';
import { countriesList } from '@utils/params';

const __selectCountry = (_, selectedCountry) => {
	const lowerSelectedCountry = selectedCountry.toLowerCase();

	if (checkDocument()) {
		window.localStorage.setItem('selectedCountry', lowerSelectedCountry);
	}

	return {
		selectedCountry: lowerSelectedCountry,
	};
};

const getInitialCountry = () => {
	if (checkDocument()) {
		const selectedCountry = Harpic(
			window.localStorage.getItem('selectedCountry')
		);

		if (selectedCountry && countriesList.indexOf(selectedCountry) > -1) {
			return selectedCountry;
		}
	}

	return GetURLParams('country') || 'in';
};

export const countryActions = () => ({
	__selectCountry,
});

export const initialCountryState = {
	selectedCountry: getInitialCountry(),
};
